import React, { useEffect } from 'react';
import { useState } from "react"
import type { CompanyProps, MyPlayerProps, PlayerBalanceProps, SquaresCompetitionProps } from "../../src/types"
import SquaresHolder from "./components/SquaresHolder";
import { SquaresApi } from '../../src/Squares/api';
import { Button, Text, View } from '../../src/Components/Themed';
import { Components } from 'be-components';
import moment from 'moment-mini';
import { Icons } from '../../src/Components';
import { useColors } from '../../src/constants/useColors';
import { Image } from 'react-native';

type SquaresWidgetProps = {
    company:CompanyProps,
    mode:'desktop'|'mobile',
    distinct_id:string,
    layout: 'card'|'banner',
    insets: { top:number, bottom:number, left:number, right:number },
    me?:MyPlayerProps,
    my_balance?:PlayerBalanceProps,
    onShowWallet:() => void,
    onShowProfile:() => void,
    onRequestAuthenticate:() => void
}

const SquaresWidget = ({ company, mode, layout, distinct_id, insets, me, my_balance, onShowProfile, onShowWallet, onRequestAuthenticate }:SquaresWidgetProps) => {
    const Colors = useColors();
    const [ state, setState ] = useState<{
        loading:boolean,
        offset:number
        squares_competitions:SquaresCompetitionProps[],
        squares: {
            visible:boolean,
            sq_comp_id?:string
        }
    }>({
        loading: false,
        offset: 0,
        squares_competitions: [],
        squares: { visible: false }
    });
    const { loading, squares, offset, squares_competitions } = state;
    const sorted_competitions = squares_competitions.sort((a,b) => {
        return moment(a.begin_datetime).unix() - moment(b.begin_datetime).unix()
    });
    useEffect(() => {
        SquaresApi.setEnvironment();
        getData(company.company_id, 0);
    },[company.company_id, me?.player_id]);

    const getData = async(id:string, page:number) => {
        setState({ ...state, loading:true });
        const squares = await SquaresApi.getSquaresCompetitionsByCompany(id, 'active', page);
        console.log(squares)
        setState({
            ...state,
            loading:false,
            offset:page,
            squares_competitions: squares
        });
    }


    const renderCompetitions = (data:{ item:SquaresCompetitionProps, index:number, horizontal:boolean }) => {
        if(data.horizontal){
            return (
                <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <Image
                        source={{ uri: data.item.image?.url }}
                        style={{ height:35, width:35 }}
                        resizeMode='cover'
                    />
                    <View transparent style={{ width: 225, marginLeft:10, marginRight:10 }}>
                        <Text theme='h2'>{data.item.sq_comp_name}</Text>
                        <Text theme='description' style={{ marginTop:3 }}>{data.item.sq_comp_description}</Text>
                    </View>
                    <Button
                        type={data.item.status == 'active' ? 'success' : 'action'}
                        title='PLAY'
                        style={{ padding:10 }}
                        onPress={() => {
                            setState({
                                ...state,
                                squares: {
                                    visible: true,
                                    sq_comp_id: data.item.sq_comp_id
                                }
                            })
                        }}
                    />
                </View>
            )
        }
        return (
            <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <Image
                    source={{ uri: data.item.image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h1'>{data.item.sq_comp_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.sq_comp_description}</Text>
                </View>
                <Button
                    type={data.item.status == 'active' ? 'success' : 'action'}
                    title='PLAY'
                    onPress={() => {
                        setState({
                            ...state,
                            squares: {
                                visible: true,
                                sq_comp_id: data.item.sq_comp_id
                            }
                        })
                    }}
                />
            </View>
        )
    }

    const renderSquares = () => {
        switch(layout){
            case 'banner':
                return (
                    <View transparent style={{ flex:1, flexDirection:'row' }}>
                        <View transparent style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                            <Icons.BettorEdgeIcon size={16} color={Colors.text.h1} />
                        </View>
                        <Components.AutoScrollingFlatList
                            data={sorted_competitions}
                            speed={10}
                            horizontal
                            renderItem={({ item, index }) => renderCompetitions({ item, index, horizontal:true })}
                            key='popular_list'
                        />
                    </View>
                )
            case 'card':
                return (
                    <View float transparent style={{ flex:1, minHeight:400 }}>
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                            <View transparent style={{ marginRight:10, justifyContent:'center', alignItems:'center' }}>
                                <Icons.BettorEdgeIcon size={16} color={Colors.text.h1} />
                            </View>
                            <View transparent style={{ flex:1, padding:5 }}>
                                <Text theme='h1'>Auction Squares</Text>
                                <Text theme='description' style={{ marginTop:3 }}>Play auction squares powered by BettorEdge</Text>
                            </View>
                        </View>
                        <View transparent type='body' style={{ flex:1 }}>
                            <Components.AutoPageFlatList
                                time_on_page={10}
                                itemHeight={110}
                                reset_key={'NONE'}
                                data={sorted_competitions}
                                renderItem={({ item, index }) => renderCompetitions({ item, index, horizontal: false })}
                            />
                        </View>
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            {renderSquares()}
            <SquaresHolder
                me={me}
                company={company}
                onRequestAuthenticate={onRequestAuthenticate}
                onShowProfile={onShowProfile}
                onShowWallet={onShowWallet}
                distinct_id={distinct_id}
                insets={insets}
                onRequestLocation={() => console.log('')}
                mode={mode}
                onClose={() => setState({ ...state, squares: { visible: false } })}
                my_balance={my_balance}
                sq_comp_id={squares.sq_comp_id}
                visible={squares.visible}

            />    
        </View>
        
    )
}


export default SquaresWidget